import { Api } from 'src/core/decorators/dto/api.decorator';
import { DtoHasApi } from '../../shared/dto-has-api.model';
import { GenAIProjectPromptDto } from './gen-ai-project-prompt.dto';
import { GenAIProjectResponseDto } from './gen-ai-project-response.dto';
import { CategoryDto } from '../../query/category.dto';
import { GenAIProjectConversationDto } from './gen-ai-project-conversation.dto';

@Api('api/app/gen-ai-project')
export class GenAIProjectDto extends DtoHasApi {
  id: number;
  version: number;
  name: string;
  startDate: Date;
  endDate: Date;
  language: string;
  useSameSample: boolean;
  isCustomPrompt: boolean;
  categoryId: string;
  typeId: number;
  statusId: number;
  lastModificationDate: Date;
  category: CategoryDto;
  prompts: GenAIProjectPromptDto[];
  responses: GenAIProjectResponseDto[];
  conversations: GenAIProjectConversationDto[];
}
